import { c as _c } from "react/compiler-runtime";
import type { font_sizes } from '@hookdeck/theme';
import Text from '../../base/Text';
import { StyledUtilsProps } from '../../helpers/StyledUtils';
import { StyledCheckbox } from './CheckboxInput';
interface Props extends StyledUtilsProps {
  label: string | JSX.Element;
  name: string;
  checked: boolean;
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
  disabled?: boolean;
  mono?: boolean;
  size?: keyof typeof font_sizes;
  highlight?: boolean;
  rounded?: boolean;
}
const Checkbox: React.FC<Props> = t0 => {
  const $ = _c(22);
  let checked;
  let label;
  let mono;
  let name;
  let onChange;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      label,
      checked,
      name,
      onChange,
      mono,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = label;
    $[3] = mono;
    $[4] = name;
    $[5] = onChange;
    $[6] = props;
    $[7] = size;
  } else {
    checked = $[1];
    label = $[2];
    mono = $[3];
    name = $[4];
    onChange = $[5];
    props = $[6];
    size = $[7];
  }
  const t1 = !!label;
  let t2;
  if ($[8] !== checked || $[9] !== name || $[10] !== onChange || $[11] !== props.disabled) {
    t2 = <input name={name} type="checkbox" checked={checked} disabled={props.disabled} onChange={onChange} />;
    $[8] = checked;
    $[9] = name;
    $[10] = onChange;
    $[11] = props.disabled;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== label || $[14] !== mono || $[15] !== size) {
    t3 = typeof label === "string" ? <Text as="span" size={size} mono={mono}>{label}</Text> : label;
    $[13] = label;
    $[14] = mono;
    $[15] = size;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== props || $[18] !== t1 || $[19] !== t2 || $[20] !== t3) {
    t4 = <StyledCheckbox as="label" has_label={t1} {...props}>{t2}{t3}</StyledCheckbox>;
    $[17] = props;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
};
export default Checkbox;